import React from "react";
import { Skeleton } from "@mui/material";

const SkeletonCard = () => {
  return (
    <div className="border border-blue-gray-500 rounded-3xl bg-white">
      <div className="border-b border-blue-gray-100/50 px-3 py-4 flex justify-between items-center">
        <Skeleton variant="text" width={150} height={24} />
      </div>
      <div className="flex justify-center items-center flex-col">
        <div className="px-3 py-2">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton
            variant="text"
            width={120}
            height={20}
            style={{ marginTop: 8 }}
          />
        </div>
        <div className="my-3 px-3">
          <Skeleton variant="circular" width={100} height={100} />
        </div>
      </div>
    </div>
  );
};

const SkeletonGrid = () => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 my-10">
      {Array.from(new Array(10)).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
};

export default SkeletonGrid;
